<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-container>
        <v-row class="mt-2">
            <v-col cols="12" md="4">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12" class="d-flex">
                                <h5 class="mt-1">Selecciona Responsable</h5>
                                <v-btn @click="d_tecnicos=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mt-5">
                            <v-col cols="12" md="5" class="mt-n5">
                                <v-text-field placeholder="Rut" class='casilla_grey text-body-2' v-model="rut" dense rounded readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n5">
                                <v-text-field placeholder="Nombre" class='casilla_grey text-body-2' v-model="razon" dense rounded readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n5">
                                <v-text-field placeholder="Usuario" class='casilla_grey text-body-2' v-model="contacto" dense rounded readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n5">
                                <v-text-field placeholder="Telefono" class='casilla_grey text-body-2' v-model="telefono" dense rounded readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n5">
                                <v-text-field placeholder="Email" class='casilla_grey text-body-2' v-model="email" dense rounded readonly></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="8">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                             <v-container>
                                <v-row>
                                    <v-col cols="8" md="3" >
                                        <v-text-field label="N° Orden" class='casilla_grey text-body-2' v-model="orden" dense rounded readonly></v-text-field>
                                        <!-- <v-text-field v-if="btn_editar!=true" label="N° Orden" class='casilla_beige text-body-2' v-model="orden" dense rounded></v-text-field>
                                        <v-text-field v-else label="N° Orden" class='casilla_grey text-body-2' v-model="orden" dense rounded disabled></v-text-field> -->
                                    </v-col>
                                    <v-col cols="12" md="9" class="text-end">
                                        <strong class="mt-1">Editar Orden</strong>
                                        <v-btn @click="d_orders=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="8" md="3" class="mt-n2 d-flex">
                                        <v-icon class="mt-0">event</v-icon>
                                            <v-text-field class='casilla_grey text-body-2' v-model="inicio" label="F. de Inicio" readonly dense rounded></v-text-field>
                                        <!-- <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field class='casilla_beige text-body-2' v-model="inicio" label="F. de Inicio" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="inicio" @input="menu1 = false"></v-date-picker>
                                        </v-menu> -->
                                    </v-col>
                                    <v-col cols="10" md="4" class="mt-n2 d-flex" >
                                        <v-icon class="mt-0">timer</v-icon>
                                        <v-text-field class='casilla_grey text-body-2' v-model="hora_inicio" label="Hora" readonly dense rounded></v-text-field>
                                        <!-- <v-select class='casilla_grey text-body-2' v-model="hora_inicio" :items="horas" label="Hora" dense rounded readonly></v-select> -->
                                        <h1 class="ml-1 mr-1 mt-n2">:</h1>
                                        <v-text-field class='casilla_grey text-body-2' v-model="minuto_inicio" label="Minuto" readonly dense rounded></v-text-field>
                                        <!-- <v-select class='casilla_grey text-body-2' v-model="minuto_inicio" :items="minutos" label="Minuto" dense rounded readonly></v-select> -->
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="8" md="3" class="mt-n2 d-flex">
                                        <v-icon class="mt-0">event</v-icon>
                                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field class='casilla_beige text-body-2' v-model="entrega" label="F. de Entrega" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="entrega" @input="menu2 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="10" md="4" class="mt-n2 d-flex">
                                        <v-icon class="mt-0">timer</v-icon>
                                        <v-select class='casilla_beige text-body-2' v-model="hora_entrega" :items="horas" label="Hora" dense rounded></v-select>
                                        <h1 class="ml-1 mr-1 mt-n2">:</h1>
                                        <v-select class='casilla_beige text-body-2' v-model="minuto_entrega" :items="minutos" label="Minuto" dense rounded></v-select>
                                    </v-col>
                                </v-row>
                             </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row class="mt-n2">
                    <v-col cols="12" md="12">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                             <v-container>
                                <v-row>
                                    <v-col cols="12" md="8" class="d-flex">
                                        <h5 class="mt-1">Selecciona Producto</h5>
                                        <v-btn @click="d_products=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="8" md="4">
                                        <!-- <v-text-field label="Cod. Barra" class='casilla_beige text-body-2' v-model="barra" dense rounded></v-text-field> -->
                                        <v-text-field class='casilla_beige text-body-2' id="barr" label="Cod. Barra"
                                            @change="captureBarra(barra)" v-model="barra" dense rounded>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- <v-row class="mt-5">
                                    <v-col cols="12" md="3" class="mt-n5">
                                        <v-text-field placeholder="Sku" class='casilla_grey text-body-2' v-model="codigo" dense rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="9" class="mt-n5">
                                        <v-text-field placeholder="Producto" class='casilla_grey text-body-2' v-model="producto" dense rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3" class="mt-n5">
                                        <v-text-field placeholder="Marca" class='casilla_grey text-body-2' v-model="marca" dense rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3" class="mt-n5">
                                        <v-text-field placeholder="Modelo" class='casilla_grey text-body-2' v-model="modelo" dense rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3" class="mt-n5">
                                        <v-text-field placeholder="Serie" class='casilla_grey text-body-2' v-model="serie" dense rounded disabled></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3" class="mt-n5">
                                        <v-text-field placeholder="Precio" class='casilla_grey text-body-2' v-model="precio" dense rounded disabled></v-text-field>
                                    </v-col>
                                </v-row> -->
                             </v-container>
                        </v-sheet>
                    </v-col>                    
                </v-row>
            </v-col>
        </v-row>
        <v-row style="background-color: lightblue;">
            <v-col cols="8">
                <h5 class="mt-0">DETALLE PRODUCTOS</h5>
            </v-col>
            <v-col cols="4" class="text-end">
                <h5 class="mt-0 grey--text">BODEGA: ( {{ nombre_bodega }} )</h5>
            </v-col>
        </v-row>
        <br>
        <!-- <div class="scroller"> -->
        <div>
            <v-sheet  v-for="item in ot_detalle" :key="item.sku" class="mb-1" style="border:1px solid lightgray; background-color: #F5F5F5;" width="100%" rounded>
              <v-container>
                <v-row class="mt-2">
                    <v-col cols="3" md="1" class="mt-n5">
                        <h6 class="grey--text">Sku</h6>
                        <h5>{{item.codigo}}</h5>
                    </v-col>
                    <v-col cols="9" md="3" class="mt-n5">
                        <h6 class="grey--text">Producto</h6>
                        <h5>{{item.producto}}</h5>
                    </v-col>
                    <v-col cols="7" md="3" class="mt-n5">
                        <h6 class="grey--text">Marca - Modelo - Serie</h6>
                        <h5>{{item.marca}} - {{item.modelo}} - {{item.serie}}</h5>
                    </v-col>
                    <v-col cols="3" md="2" class="mt-n5">
                        <h6 class="grey--text">Precio</h6>
                        <h5>${{new Intl.NumberFormat('de-DE').format(item.precio)}}</h5>
                    </v-col>
                    <v-col cols="2" md="1" class="mt-n5">
                        <h6 class="grey--text">Cantidad</h6>
                        <div class="d-flex">
                            <h5>{{new Intl.NumberFormat('de-DE').format(item.cantidad)}}</h5>
                            <v-icon v-if="parseInt(item.contenido)!=0"  class="ml-2" small color="grey">adjust</v-icon>
                            <v-icon v-else @click="open_count(item)" class="ml-2" small color="teal">adjust</v-icon>
                        </div>
                    </v-col>
                    <v-col cols="6" md="1" class="mt-n5">
                        <h6 class="grey--text">Estado</h6>
                        <v-badge :content="item.contenido" :color="item.color">
                            <v-btn @click="open_history(item)" x-small :color="item.color" block dark>{{item.estado}}</v-btn>
                        </v-badge>
                    </v-col>
                    <v-col cols="6" md="1" class="mt-n5 text-end">
                        <h6 class="grey--text">&nbsp;</h6>
                        <v-icon v-if="btn_editar!=true" @click="delete_line(item)" small color="error">delete</v-icon>
                        <v-icon v-else small color="grey">delete</v-icon>
                    </v-col>
                </v-row>
              </v-container>
            </v-sheet>
        </div>
        <v-row class="mt-3">
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="3">
                <v-btn @click="clsInput()" color="teal" rounded dark small block>Limpiar</v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <div v-if="btn_editar!=true">
                    <v-btn v-if="btn_grabar!=true" @click="save_order()" color="teal" rounded dark small block>Grabar</v-btn>
                    <v-btn v-else color="grey" rounded dark small block>Grabar</v-btn>
                </div>
                <div v-else>
                    <v-btn v-if="btn_grabar!=true" @click="update_order()" color="teal" rounded dark small block>Actualizar</v-btn>
                    <v-btn v-else color="grey" rounded dark small block>Actualizar</v-btn>
                </div>
            </v-col>
            <v-col cols="12" md="3"></v-col>
        </v-row>
        <v-divider class="mt-5 mb-5"></v-divider>
        </v-container>

        <!-- historial de estados -->
        <v-dialog v-model="d_historial" transition="dialog-bottom-transition" max-width="450">
            <v-card>
                <v-card-title>
                    Historial de Estados
                <v-spacer></v-spacer>
                    <v-icon @click="d_historial=false" color="error">close</v-icon>
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <h5>Sku: {{ codigo }}</h5>
                        </v-col>
                        <v-col cols="6">
                            <v-btn @click="open_states()" x-small color="cyan" block dark rounded>Nuevo Estado</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-5"></v-divider>
                    <v-carousel height="300" v-model="idCarrusel">
                        <v-carousel-item v-for="item in carruselCode" :key="item.id">
                            <v-row class="mt-5">
                                <v-col cols="8" md="5" class="mt-n2 d-flex">
                                    <v-icon class="mt-1">event</v-icon>
                                    <v-text-field class='casilla_grey text-body-2' v-model="item.fecha" label="Fecha" readonly dense rounded ></v-text-field>
                                </v-col>
                                <v-col cols="10" md="7" class="mt-n2 text-center">
                                    <v-text-field class='casilla_grey text-body-2' v-model="item.text" label="Estado" readonly dense rounded ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" class="mt-n2">
                                    <v-textarea class='text-body-2' no-resize rows="4" v-model="item.observa" label="Observación" disabled outlined dense rounded></v-textarea>
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                    </v-carousel>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- nuevos estados -->
        <v-dialog v-model="d_estados" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Estado del Producto
                <v-spacer></v-spacer>
                    <v-icon @click="d_estados=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="8" md="5" class="mt-n2 d-flex">
                            <v-icon class="mt-1">event</v-icon>
                            <v-text-field class='casilla_grey text-body-2' v-model="fecha_estado" label="Fecha" readonly dense rounded></v-text-field>
                            <!-- <v-menu v-model="menu3" :close-on-content-click="false" :nudge-left="15" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field class='casilla_grey text-body-2' v-model="fecha_estado" label="Fecha" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                </template>
                                <v-date-picker v-model="fecha_estado" @input="menu3 = false"></v-date-picker>
                            </v-menu> -->
                        </v-col>
                        <v-col cols="10" md="7" class="mt-n2 text-center">
                            <v-select label="Nuevo Estado" class='casilla_beige text-body-2 black--text' v-model="estado" :items="myStatus" item-text="text" item-value="id" dense rounded></v-select>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n2">
                            <v-textarea label="Observación" class='text-body-2' no-resize rows="4" outlined dense rounded v-model="observa"></v-textarea>
                        </v-col>
                        <v-col cols="12" class="mt-n10">
                            <v-btn @click="add_states()" small color="teal" block dark rounded>Agregar Estado</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- cantidad del producto -->
        <v-dialog v-model="d_cantidad" transition="dialog-bottom-transition" max-width="450">
             <v-card>
                <v-card-title>
                    Cantidad del Producto
                <v-spacer></v-spacer>
                    <v-icon @click="d_cantidad=false" color="error">close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="mt-5">
                        <v-col cols="6">
                            <h3>Sku: {{ codigo }}</h3>
                        </v-col>
                        <v-col cols="8" md="5">
                            <v-text-field label="Cantidad" type="number" class='casilla_beige text-body-2' v-model="cantidad" dense rounded></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-btn @click="add_count()" small color="teal" block dark rounded>Agregar Cantidad</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
             </v-card>
        </v-dialog>

        <!-- lista de productos -->
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Productos</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="products_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProducts" dense dark height="400px" fixed-header
                    :search="products_search" :headers="products_titulo" :items="products_lista" 
                    :page.sync="products_page" :items-per-page="products_itemsPerPage"  
                    @page-count="products_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.codigo="{ item }">
                        <v-chip small>
                            {{ item.codigo }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="products_page" :length="products_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- lista de ordenes -->
        <v-dialog v-model="d_orders" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_orders=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Ordenes de Trabajo</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="orders_search" label="Buscar Orden" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleOrders" dense dark height="400px" fixed-header
                    :search="orders_search" :headers="orders_titulo" :items="orders_lista" 
                    :page.sync="orders_page" :items-per-page="orders_itemsPerPage"  
                    @page-count="orders_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.orden="{ item }">
                        <v-chip small>
                            {{ item.orden }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="orders_page" :length="orders_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- lista de responsables -->
        <v-dialog v-model="d_tecnicos" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_tecnicos=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-2 text-body-2">Responsables</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="tecnicos_search" label="Buscar Responsable" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleTecnicos" dense dark height="400px" fixed-header
                    :search="tecnicos_search" :headers="tecnicos_titulo" :items="tecnicos_lista" 
                    :page.sync="tecnicos_page" :items-per-page="tecnicos_itemsPerPage"  
                    @page-count="tecnicos_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.rut="{ item }">
                        <v-chip small>
                            {{ item.rut }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="tecnicos_page" :length="tecnicos_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_table {
    background-color: beige; 
    height: 25px;
    border: 1px solid lightgray;
}
.scroller {
  height: 18em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  /*border: 1px solid lightgray;*/
}
</style>
<script>
import axios from "axios";
export default {
  name: 'OrdenTrabajo',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,

    snack:false,
    color_snack:'',
    mensaje:'',

    rut:'',
    razon:'',
    contacto:'',
    telefono:'',
    email:'',

    orden:'',
    menu1:false,
    inicio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

    menu2:false,
    entrega:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

    menu3:false,
    fecha_estado:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

    responsable:0,

    barra:'',
    codigo:'',
    producto:'',
    marca:'',
    modelo:'',
    serie:'',
    precio:'',
    cantidad:'',
    stock:0,
    d_cantidad:false,

    presupuesto:0,

    d_historial:false,
    d_estados:false,
    estado:'',
    myStatus:[],
    observa:'',

    idCarrusel:0,
    carruselStates:[],
    carruselCode:[],

    ot_detalle:[],
    lineas:0,
    
    d_products:false,
    products_titulo: [
      { text: 'Sku', align: 'start', sortable: true, value: 'codigo' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Marca', align: 'start', sortable: true, value: 'txt_marca' },
      { text: 'Modelo', align: 'start', sortable: true, value: 'modelo' },
      { text: 'Serie', align: 'start', sortable: true, value: 'serie' },
      { text: 'Stock', align: 'start', sortable: true, value: 'stock' },
    ],
    products_lista: [],
    products_page: 1,
    products_pageCount: 0,
    products_itemsPerPage: 1000000,
    products_search:'',
    products_all:[],

    d_tecnicos:false,
    tecnicos_titulo: [
      { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
      { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
      { text: 'Usuario', align: 'start', sortable: true, value: 'usuario' },
      { text: 'Telefono', align: 'start', sortable: true, value: 'telefono' },
      { text: 'Email', align: 'start', sortable: true, value: 'email' },
    ],
    tecnicos_lista: [],
    tecnicos_page: 1,
    tecnicos_pageCount: 0,
    tecnicos_itemsPerPage: 1000000,
    tecnicos_search:'', 
    
    d_orders:false,
    orders_titulo: [
      { text: 'Orden', align: 'start', sortable: true, value: 'orden' },
      { text: 'Fecha', align: 'start', sortable: true, value: 'inicio' },
      { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
      { text: 'Responsable', align: 'start', sortable: true, value: 'responsable' },
    ],
    orders_lista: [],
    orders_page: 1,
    orders_pageCount: 0,
    orders_itemsPerPage: 1000000,
    orders_search:'', 

    btn_grabar:false,
    bloqueo:null,
    loading:false,
    numClicks:0,
    btn_editar:false,
    key_barra:0,

    horas: ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
    minutos: ['00','05','10','15','20','25','30','35','40','45','50','55'],
    hora_inicio: '00' ,
    minuto_inicio:'00',
    hora_entrega:'00',
    minuto_entrega:'00',
    nombre_bodega:'',
    tipo:'producto',

  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    //this.fecha=this.formatFecha(this.hoy);
    this.bloqueo = await this.myPermiso(2);
    if(parseInt(this.bloqueo)!=0){
        const hora_fija = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(11, 16);
        console.log(hora_fija);
        this.hora_inicio = hora_fija.substring(0,2);
        this.minuto_inicio = hora_fija.substring(3,5);
        await this.searchNameBodegas(1);
        await this.searchStatusProducts();
        await this.searchResponsable();
        await this.searchProducts();
        await this.searchOrders();
    }
    this.loading=false;
  },
  methods:{
    focusBarra(){
        var elemento = document.getElementById("barr");
        elemento.focus();
        this.barra="";
    },
    captureBarra(codBarra){
        console.log('entra');
        if(this.barra.trim()!=''){
            const resultado = this.products_lista.filter(res => res.barra == codBarra);
            if(resultado.length!=0){
                const element = resultado[0];
                this.handleProducts(element);
                this.focusBarra();
            } else {
                this.mensaje='Producto no existe';
                this.color_snack='red';
                this.snack=true;
                this.focusBarra();
            };
        }
    },
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async searchNameBodegas(id){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                bodega : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/bodegas/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.nombre_bodega=datos[0].bodega
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async open_history(line){
        this.codigo=line.codigo;
        if(this.carruselStates.length!=0){
            this.carruselCode = this.carruselStates.filter(res => res.codigo == line.codigo);
        }
        this.d_historial=true;
    },
    async open_states(){
        this.estado='';
        this.observa='';
        this.d_estados=true;
    },
    async add_detail(){
        if(this.ot_detalle.length!=0){
            //buscamos si existe el codigo
            const dataDetalle = this.ot_detalle.filter(res => res.codigo == this.codigo);
            if(dataDetalle.length!=0){
                //verificamos que la cantidad no supere el stock
                const cantidad_old = dataDetalle[0].cantidad;
                const cantidad_stock = dataDetalle[0].stock;
                if(parseFloat(cantidad_stock) > parseFloat(cantidad_old)){
                    //sumar 1 a la cantidad
                    const cantidad_new = parseFloat(cantidad_old) + 1;
                    //actualizar la cantidad
                    dataDetalle[0].cantidad = cantidad_new
                } else {
                    this.mensaje='No hay mas stock';
                    this.color_snack='red';
                    this.snack=true;
                }
            } else {
                //agregar un nuevo item a la lista
                const id_line = this.ot_detalle.length + 1;
                this.ot_detalle.push({
                    id: id_line,
                    fecha: this.inicio,
                    codigo: this.codigo,
                    producto: this.producto,
                    marca: this.marca,
                    modelo: this.modelo,
                    serie: this.serie,
                    precio: this.precio,
                    cantidad: 1,
                    id_estado: 0,
                    estado: 'Pendiente',
                    color: 'grey',
                    contenido: 0,
                    stock: this.stock
                });
            }
        } else {
            //agregar un nuevo item a la lista
            const id_line = this.ot_detalle.length + 1;
            this.ot_detalle.push({
                id: id_line,
                fecha: this.inicio,
                codigo: this.codigo,
                producto: this.producto,
                marca: this.marca,
                modelo: this.modelo,
                serie: this.serie,
                precio: this.precio,
                cantidad: 1,
                id_estado: 0,
                estado: 'Pendiente',
                color: 'grey',
                contenido: 0,
                stock: this.stock
            });
        }
    },
    async add_states(){
        const found = this.myStatus.filter(res => parseInt(res.id) == parseInt(this.estado));
        if(found.length!=0){
            this.carruselStates.push({
                codigo: this.codigo,
                id: this.estado,
                fecha: this.fecha_estado, 
                text: found[0].text,
                color: found[0].color,
                observa: this.observa
            });
            this.idCarrusel=this.carruselStates.length - 1
            //update estado
            const filter = this.ot_detalle.filter(res => res.codigo == this.codigo);
            const total = this.carruselStates.filter(res => res.codigo == this.codigo);
            if(filter.length!=0){
                filter[0].id_estado = this.estado;
                filter[0].estado = found[0].text;
                filter[0].color = found[0].color;
                filter[0].contenido = total.length;
            };
            //filtramos por el codigo 
            this.carruselCode = this.carruselStates.filter(res => res.codigo == this.codigo);
        };
        this.d_estados=false;
    },
    async open_count(line){
        this.cantidad=line.cantidad;
        this.codigo=line.codigo;
        this.d_cantidad=true;
    },
    async add_count(){
        if(this.cantidad!='' && this.cantidad!= null){
            if(parseInt(this.cantidad)>0){
                const filter = this.ot_detalle.filter(res => res.codigo == this.codigo);
                if(filter.length!=0){
                    const filter_stock = filter[0].stock;
                    if(parseFloat(filter_stock) > parseFloat(this.cantidad)){
                        filter[0].cantidad = this.cantidad;
                    } else {
                        this.mensaje='No hay mas stock';
                        this.color_snack='red';
                        this.snack=true;
                    }
                }
            }
        }
        this.d_cantidad=false
    },
    delete_line(line){
        this.ot_detalle = this.ot_detalle.filter(function(dat) {
            return dat.id !== line.id; 
        });
    },
    async clsInput(){
        this.rut='';
        this.razon='';
        this.contacto='';
        this.telefono='';
        this.email='';
        this.orden='';
        this.inicio=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.entrega=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.hora_inicio='00',
        this.minuto_inicio='00',
        this.hora_entrega='00',
        this.minuto_entrega='00',
        this.fecha_estado=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
        this.responsable=0;
        this.barra='';
        this.codigo='';
        this.producto='';
        this.marca='';
        this.modelo='';
        this.serie='';
        this.precio='';
        this.cantidad='';
        this.presupuesto=0;
        this.estado='';
        this.observa='';
        this.idCarrusel=0;
        this.carruselStates=[];
        this.carruselCode=[];
        this.ot_detalle=[];
        this.lineas=0; 
        this.products_search='';
        this.btn_grabar=false;
        this.numClicks=0;
        this.btn_grabar=false;
        this.btn_editar=false;
    },
    async searchStatusProducts(){
        this.myStatus=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/status/products/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.myStatus.push({
                        id: element.id_estado,
                        text: element.texto,
                        color: element.color
                    })                    
                });
            }
        } catch (error) {
            console.log(error)
        }
    },
    async searchResponsable(){
        this.tecnicos_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                usuario: 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    if(element.tipo=='Tecnico'){
                        this.tecnicos_lista.push(element)
                    }
                });
            }
        } catch (error) {
            console.log(error)
        }
    },
    async searchProducts(){
        try {
            this.products_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                sku :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/inventary/detail/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    const elStock = element.stock;
                    const elBodega = element.st_bodega;
                    if(parseFloat(elStock)!=0 && parseInt(elBodega)==1){
                        this.products_lista.push(element)        
                    }
                });
                this.products_all=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    handleProducts(item){
        this.codigo = item.codigo;
        this.producto = item.producto;
        this.marca = item.txt_marca;
        this.modelo = item.modelo;
        this.serie = item.serie;
        this.precio = item.precio_detalle;
        this.stock = item.stock;
        this.add_detail();
        this.d_products = false;
    },
    handleTecnicos(item){
        this.responsable = item.ID;
        this.rut = item.rut;
        this.razon = item.nombre;
        this.contacto = item.usuario;
        this.telefono = item.telefono;
        this.email = item.email;
        this.d_tecnicos = false;
    },
    async searchOrders(){
        try {
            this.orders_lista=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
                orden :  'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.orders_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async handleOrders(item){
        this.loading=true;
        //buscar datos de los tecnicos
        const dataResponsable = this.tecnicos_lista.filter(res => res.rut == item.rut);
        if(dataResponsable.length!=0){
            this.responsable = dataResponsable[0].ID;
            this.rut = dataResponsable[0].rut;
            this.razon = dataResponsable[0].nombre;
            this.contacto = dataResponsable[0].usuario;
            this.telefono = dataResponsable[0].telefono;
            this.email = dataResponsable[0].email;
        };
        //agregamos los datos de la orden
        this.orden = item.orden;
        this.inicio = item.inicio;
        this.entrega = item.entrega;
        this.hora_inicio = item.hora_inicio.substring(0,2);
        this.minuto_inicio = item.hora_inicio.substring(3,5);
        this.hora_entrega = item.hora_entrega.substring(0,2);
        this.minuto_entrega = item.hora_entrega.substring(3,5);
        //buscamos el detalle de la orden
        await this.serachDetailOT();
        await this.searchStatus();
        //actualizamos el status de cada codigo
        if(this.carruselStates.length!=0){
            for (let index = 0; index < this.ot_detalle.length; index++) {
                const element = this.ot_detalle[index];
                //buscamos el carrusel del codigo
                const dataCodigo = this.carruselStates.filter(res => res.codigo == element.codigo);
                if(dataCodigo.length!=0){
                    const ultimo = dataCodigo.length -1;
                    element.id_estado = dataCodigo[ultimo].id;
                    element.estado = dataCodigo[ultimo].text;
                    element.color = dataCodigo[ultimo].color;
                    element.contenido = dataCodigo.length;
                }
            }

        };
        this.btn_editar=true;
        this.loading=false;
        this.d_orders = false;
    },
    async serachDetailOT(){
        try {
            this.ot_detalle=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                orden : this.orden,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/detail/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                let id_line = 1;
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    //buscarmos los datos del producto
                    const dataProducto = this.products_all.filter( res => res.codigo == element.codigo );
                    let pro_producto = '';
                    let pro_marca = '';
                    let pro_modelo = '';
                    let pro_serie = '';
                    let pro_stock = '';
                    if(dataProducto.length!=0){
                        pro_producto = dataProducto[0].producto;
                        pro_marca = dataProducto[0].txt_marca;
                        pro_modelo = dataProducto[0].modelo;
                        pro_serie = dataProducto[0].serie;
                        pro_stock = dataProducto[0].stock;
                    };
                    this.ot_detalle.push({
                        id: id_line,
                        fecha: element.fecha,
                        codigo: element.codigo,
                        producto: pro_producto,
                        marca: pro_marca,
                        modelo: pro_modelo,
                        serie: pro_serie,
                        precio: element.precio,
                        cantidad: element.cantidad,
                        id_estado: 0,
                        estado: 'Pendiente',
                        color: 'grey',
                        contenido: 0,
                        stock: pro_stock
                    });
                    id_line = parseInt(id_line) + 1
                }
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async searchStatus(){
        try {
            this.carruselStates=[];
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                orden : this.orden,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/status/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    //buscarmos el texto del estado
                    let txtEstado = '';
                    let colorEstado = '';
                    const dataEstado = this.myStatus.filter( res => res.id == element.estado );
                    if(dataEstado.length!=0){
                        txtEstado = dataEstado[0].text;
                        colorEstado = dataEstado[0].color
                    };
                    this.carruselStates.push({
                        codigo: element.codigo,
                        id: element.estado,
                        fecha: element.fecha, 
                        text: txtEstado,
                        color: colorEstado, 
                        observa: element.observa
                    });
                }
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async save_order(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            this.orden='';
             //obtener numero de orden automatico
            const timestamp = Date.now();
            const params = {
                contrato : this.contrato,
                user :  this.user,
                clave: timestamp
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/ot/number/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.orden=datos[0].id;
            };
            //verificamos si la orden existe
            let sigue = 'no';
            if(this.orden!='' && this.orden!=null){
                if(this.rut!=''){
                    if(parseInt(this.responsable)!=0){
                        if(this.orders_lista.length!=0){
                            const filter = this.orders_lista.filter(res => res.orden == this.orden);
                            if(filter.length!=0){
                                sigue='no'
                            } else {
                                sigue='si'
                            }
                        } else {
                            sigue='si'
                        };
                        if(sigue=='si'){
                            this.loading=true;
                            if(this.ot_detalle.length!=0){
                                if(parseInt(this.numClicks)==0){
                                    const grabar = await this.save_ot();
                                    if(grabar==true){
                                        await this.save_detail();
                                        await this.save_status();
                                        await this.searchOrders();
                                        await this.searchProducts();
                                        this.mensaje='Orden de trabajo ingresada';
                                        this.color_snack='success';
                                        this.snack=true;
                                    } else {
                                        this.mensaje='No es posible grabar OT';
                                        this.color_snack='red';
                                        this.snack=true;
                                    }
                                    this.btn_grabar=true;
                                    this.numClicks = parseInt(this.numClicks) + 1
                                }
                            } else {
                                this.mensaje='Lista sin productos';
                                this.color_snack='red';
                                this.snack=true;
                            }
                            this.loading=false;
                        } else {
                            this.mensaje='La orden ya existe';
                            this.color_snack='red';
                            this.snack=true;
                        } 
                    } else {
                        this.mensaje='Ingrese responsable';
                        this.color_snack='red';
                        this.snack=true;
                    }
                } else {
                    this.mensaje='Ingrese datos del responsable';
                    this.color_snack='red';
                    this.snack=true;
                }
            } else {
                this.mensaje='Ingrese Orden de Trabajo';
                this.color_snack='red';
                this.snack=true;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async save_ot(){
        let result=false;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                orden : this.orden,
                rut: this.rut,
                inicio: this.inicio,
                entrega: this.entrega,
                hora_inicio: this.hora_inicio + ':' + this.minuto_inicio,
                hora_entrega: this.hora_entrega + ':' + this.minuto_entrega,
                responsable: this.responsable
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result=true;
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async save_detail(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            for (let index = 0; index < this.ot_detalle.length; index++) {
                const element = this.ot_detalle[index];
                const params = {
                    contrato : this.contrato,
                    user : this.user,
                    fecha: this.inicio,
                    orden : this.orden,
                    codigo: element.codigo,
                    precio: element.precio,
                    cantidad: element.cantidad,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/detail/order/job/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    console.log('save:', element.codigo);
                }                
            }
        } catch (error) {
            console.log(error)
        }
    },
    async save_status(){
        try {
            if(this.carruselStates.length!=0){
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                for (let index = 0; index < this.carruselStates.length; index++) {
                    const element = this.carruselStates[index];
                    const params = {
                        contrato : this.contrato,
                        user : this.user,
                        fecha: element.fecha,
                        orden : this.orden,
                        codigo: element.codigo,
                        estado: element.id,
                        observa: element.observa
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/status/order/job/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        if(parseInt(element.id)==1){
                            await this.moveStock(element.fecha, element.codigo, element.id);
                        };
                        console.log('save:', element.codigo);
                    }                
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async update_order(){
        try {
            //verificamos si la orden existe
            let sigue = 'si';
            if(this.orden!='' && this.orden!=null){
                if(this.rut!=''){
                    if(parseInt(this.responsable)!=0){
                        if(this.orders_lista.length!=0){
                            const filter = this.orders_lista.filter(res => res.orden == this.orden);
                            if(filter.length!=0){
                                sigue='si'
                            } else {
                                sigue='no'
                            }
                        } else {
                            sigue='no'
                        };
                        if(sigue=='si'){
                            this.loading=true;
                            if(this.ot_detalle.length!=0){
                                if(parseInt(this.numClicks)==0){
                                    const grabar = await this.update_ot();
                                    if(grabar==true){
                                        await this.update_detail();
                                        await this.update_status();
                                        await this.searchOrders();
                                        await this.searchProducts();
                                        this.mensaje='Orden de trabajo actualizada';
                                        this.color_snack='success';
                                        this.snack=true;
                                    } else {
                                        this.mensaje='No es posible grabar OT';
                                        this.color_snack='red';
                                        this.snack=true;
                                    }
                                    this.btn_grabar=true;
                                    this.numClicks = parseInt(this.numClicks) + 1
                                }
                            } else {
                                this.mensaje='Lista sin productos';
                                this.color_snack='red';
                                this.snack=true;
                            }
                            this.loading=false;
                        } else {
                            this.mensaje='La orden ya existe';
                            this.color_snack='red';
                            this.snack=true;
                        } 
                    } else {
                        this.mensaje='Ingrese responsable';
                        this.color_snack='red';
                        this.snack=true;
                    }
                } else {
                    this.mensaje='Ingrese datos del responsable';
                    this.color_snack='red';
                    this.snack=true;
                }
            } else {
                this.mensaje='Ingrese Orden de Trabajo';
                this.color_snack='red';
                this.snack=true;
            }            
        } catch (error) {
            console.log(error)
        }
    },
    async update_ot(){
        let result=false;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                orden : this.orden,
                rut: this.rut,
                inicio: this.inicio,
                entrega: this.entrega,
                hora_inicio: this.hora_inicio +':'+this.minuto_inicio,
                hora_entrega: this.hora_entrega +':'+this.minuto_entrega,
                responsable: this.responsable
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/order/job/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result=true;
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async update_detail(){
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            //vefificar codigos de la lista
            for (let index = 0; index < this.ot_detalle.length; index++) {
                const element = this.ot_detalle[index];
                const params = {
                    contrato : this.contrato,
                    user : this.user,
                    orden : this.orden,
                    codigo: element.codigo,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/verify/detail/order/job/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    //actualizamos el item existente
                    const params1 = {
                        contrato : this.contrato,
                        user : this.user,
                        fecha: this.inicio,
                        orden : this.orden,
                        codigo: element.codigo,
                        precio: element.precio,
                        cantidad: element.cantidad,
                    };
                    const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/detail/order/job/',params1,{headers});
                    const datos1 = res1.data;
                    if(datos1[0].existe=='si'){
                        console.log('update:', element.codigo);
                    }                
                }
                if(datos[0].existe=='no'){
                    //ingresamos el nuevo item
                    const params2 = {
                        contrato : this.contrato,
                        user : this.user,
                        fecha: this.inicio,
                        orden : this.orden,
                        codigo: element.codigo,
                        precio: element.precio,
                        cantidad: element.cantidad,
                    };
                    const res2 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/detail/order/job/',params2,{headers});
                    const datos2 = res2.data;
                    if(datos2[0].existe=='si'){
                        console.log('save:', element.codigo);
                    }                
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async update_status(){
        try {
            if(this.carruselStates.length!=0){
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                //vefificar estados de la lista
                for (let index = 0; index < this.carruselStates.length; index++) {
                    const element = this.carruselStates[index];
                    const params = {
                        contrato : this.contrato,
                        user : this.user,
                        orden : this.orden,
                        codigo: element.codigo,
                        estado: element.id,
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/verify/status/order/job/',params,{headers});
                    const datos = res.data;
                    console.log('verify status',datos)
                    if(datos[0].existe=='no'){
                        const params1 = {
                            contrato : this.contrato,
                            user : this.user,
                            fecha: element.fecha,
                            orden : this.orden,
                            codigo: element.codigo,
                            estado: element.id,
                            observa: element.observa
                        };
                        const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/status/order/job/',params1,{headers});
                        const datos1 = res1.data;
                        console.log('new save', params1)
                        if(datos1[0].existe=='si'){
                            if(parseInt(element.id)==1 || parseInt(element.id)==4){ //entregado o devuelto
                                await this.moveStock(element.fecha, element.codigo, element.id);
                            };
                            console.log('save:', element.codigo);
                        }                
                    }                
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    async moveStock(date, code, status){
        try {
            //buscar el codigo en el detalle para obtener la cantidad
            const filterDetail = this.ot_detalle.filter(res => res.codigo == code);
            if(filterDetail.length!=0){
                const myCantidad = filterDetail[0].cantidad;
                let mySigno='';
                if(parseInt(status)==1){ mySigno='0-' };
                if(parseInt(status)==4){ mySigno='0+' };
                if(mySigno!=''){
                    //grabamos el movimiento de stock
                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    }
                    const params = {
                        contrato : this.contrato,
                        user :  this.user,
                        fecha: date,
                        tipo: this.tipo,
                        codigo:  code,
                        cantidad: myCantidad,
                        signo: mySigno,
                        bodega: '1',
                        observa: '',
                        origen: 'Orden'
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/stock/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        console.log('move stock ok')
                    }
               }
            }
        } catch (error) {
            console.log(error)
        }

    },






    async selecFecha(){
      this.fecha = this.formatFecha(this.hoy);
      this.menu1 = false;
    },
    formatFecha(fec){
      const dia = fec.substring(8,10);
      const mes = fec.substring(5,7);
      const anio = fec.substring(0,4);
      const hoy = dia + '-' + mes + '-' + anio;
      return hoy;
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    onlyNumber ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },

  }
}
</script>
